module.exports = __webpack_public_path__ + "static/media/east-region-states-sm.7b89a28e.png";